/**
 * Changed the default behavior of the primary nav to expand on rollover instead of click.
 * @param e
 */
function toggleDropdown (e) {
    const _d = jQuery(e.target).closest('.dropdown'),
        _m = jQuery('.dropdown-menu', _d);
    setTimeout(function(){
        const shouldOpen = e.type !== 'click' && _d.is(':hover');
        _m.toggleClass('show', shouldOpen);
        _d.toggleClass('show', shouldOpen);
        jQuery('[data-toggle="dropdown"]', _d).attr('aria-expanded', shouldOpen);
    }, e.type === 'mouseleave' ? 300 : 0);
}
jQuery('body').on('mouseenter mouseleave', '.dropdown', toggleDropdown);

function pma_back_to_top_link() {
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 50) {
            jQuery('#back-to-top').fadeIn();
        } else {
            jQuery('#back-to-top').fadeOut();
        }
    });
    // scroll body to 0px on click
    jQuery('#back-to-top').click(function () {
        jQuery('body,html').animate({
            scrollTop: 0
        }, 400);
        return false;
    });
}

function normalizeSlideHeights() {
    jQuery('.carousel').each(function(){
      var items = jQuery('.carousel-item', this);
      // reset the height
      items.css('min-height', 0);
      // set the height
      var maxHeight = Math.max.apply(null,
          items.map(function(){
              return jQuery(this).outerHeight()}).get() );
      items.css('min-height', maxHeight + 'px');
    });
}

jQuery( function ( $ ) {
    'use strict';

    jQuery(window).on( 'load resize orientationsize', normalizeSlideHeights() );

    $('ul.dropdown-menu [data-toggle=dropdown]').on('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        $(this).parent().siblings().removeClass('open');
        $(this).parent().toggleClass('open');
    });

    pma_back_to_top_link();

    // Allow smooth scroll
    $('.page-scroller').on('click', function (e) {
        e.preventDefault();
        var target = this.hash;
        var $target = $(target);
        $('html, body').animate({
            'scrollTop': $target.offset().top
        }, 1000, 'swing');
    });

    let show_member_form_button = jQuery('#button-apply-for-membership a');
    let member_form = jQuery('#gform_2');

    let show_pay_my_dues_button = jQuery('#button-pay-my-dues a');
    let pay_dues_form = jQuery('#gform_3');

    show_member_form_button.on('click', function() {
        member_form.css('display', 'block');
        pay_dues_form.css('display', 'none');
    });

    show_pay_my_dues_button.on('click', function() {
        member_form.css('display', 'none');
        pay_dues_form.css('display', 'block');
    });
    
});